import styles from './SidebarNav.module.css'
import React, { useContext, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import {
  PlusOutlined,
  AppstoreOutlined,
  DesktopOutlined,
  EyeOutlined,
  SettingOutlined,
  HomeOutlined,
  FundProjectionScreenOutlined,
} from '@ant-design/icons'
import {
  SvgPreviewHome,
  SvgCloseSidebarLeft,
  SvgCloseSidebarRight,
  SvgChangeColor,
} from '../../../../components/svg/SvgComponents'

import { Tooltip } from 'antd'
import UserAvatar from '../../../../components/Avatar/UserAvatar'
import { BuilderContext } from '../store/store.Builder'

const SidebarNav = observer(() => {
  const builderContext = useContext(BuilderContext)

  const iconSize = '18px'

  //   Uniquement cette partie du code à modifier pour ajouter ou modifier des élements du SidebarNav
  const startItems = [
    {
      tooltip: 'Accueil',
      icon: HomeOutlined,
      type: 'link',
      href: '/workspaces/',
    },
    {
      tooltip: 'Aperçu du formulaire',
      icon: EyeOutlined,
      type: 'link',
      href: `/sandbox/${builderContext.url_code}/preview`,
      blank: true,
    },
    {
      tooltip: 'Réponses',
      icon: FundProjectionScreenOutlined,
      type: 'link',
      href: `/sandbox/${builderContext.url_code}/answers`,
      blank: true,
    },
    {
      tooltip: 'Paramètres du formulaire',
      icon: SettingOutlined,
      type: 'action',
      onClick: () =>
        builderContext.setSelectedField(builderContext.styleForm, 'form'),
    },
  ]

  const endItems = useMemo(
    () => [
      {
        tooltip: 'Profil',
        icon: () => (
          <UserAvatar hasBadge={true} userName={builderContext.userFullName} />
        ),
      },
      { tooltip: 'Paramètres', icon: SettingOutlined },
    ],
    [builderContext.userFullName]
  )

  return (
    <div className={styles.sidebarNav}>
      <div className={styles.container}>
        <div className={styles.start__container}>
          {startItems.map((item) => (
            <Tooltip
              title={item.tooltip}
              placement="right"
              color="black"
              key={item.tooltip}
            >
              {item.type === 'link' ? (
                <a
                  href={item.href}
                  rel="noopener noreferrer"
                  target={item.blank ? '_blank' : '_self'} // si blank est vrai, s'ouvrira dans un nouvel onglet
                  className={styles.btn__state__sidebarFields}
                >
                  <item.icon
                    style={
                      item.icon !== UserAvatar ? { fontSize: iconSize } : {}
                    }
                  />
                </a>
              ) : (
                <div
                  className={styles.btn__state__sidebarFields}
                  onClick={item.onClick}
                >
                  <item.icon
                    style={
                      item.icon !== UserAvatar ? { fontSize: iconSize } : {}
                    }
                  />
                </div>
              )}
            </Tooltip>
          ))}
        </div>
        <div className={styles.end__container}>
          <div className={styles.left__btn_container}>
            <div
              className={`${styles.left__svg} ${
                builderContext.isSidebarFieldsOpen
                  ? styles.small__btn_active
                  : ''
              }`}
              onClick={builderContext.toggleSidebarFields}
            >
              <div className={styles.left_i__svg}>
                <SvgCloseSidebarLeft />
              </div>
            </div>
            <div
              className={`${styles.left__svg} ${
                builderContext.isSidebarEditorOpen
                  ? styles.small__btn_active
                  : ''
              }`}
              onClick={builderContext.toggleSidebarEditor}
            >
              <div className={styles.left_i__svg}>
                <SvgCloseSidebarRight />
              </div>
            </div>
            <div
              className={styles.left__svg}
              onClick={builderContext.changeThemeColor}
            >
              <div className={styles.left_i__svg}>
                <SvgChangeColor />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default SidebarNav
